import type {YMDDate} from './dates';

// This order corresponds to the order of the days `Date.getDay()` method returns.
export const daysOfWeek = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

export const minDate: YMDDate = `1901/1/1`;
export const maxDate: YMDDate = `9999/12/31`;
